// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wordnowrap[data-v-4f060116]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
